// tslint:disable
/**
 * Beneficiaries API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BeneficiaryDto
 */
export interface BeneficiaryDto {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    transactionID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    transactionDateTimeStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    srcSysCompCd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    srcSysCompNm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    srcApplicationNm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    lastUpdatedTs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    lastUpdatedBy?: string | null;
    /**
     * 
     * @type {PolicyDto}
     * @memberof BeneficiaryDto
     */
    policy?: PolicyDto | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    imageIdentifier?: string | null;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof BeneficiaryDto
     */
    persons?: Array<PersonDto> | null;
}
/**
 * 
 * @export
 * @interface BeneficiaryPersonDto
 */
export interface BeneficiaryPersonDto {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    dateOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    identifier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryPersonDto
     */
    beneficiaryPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    email?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryPersonDto
     */
    personType?: number;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    relationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    address1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    address3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    zipcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    signatureDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonDto
     */
    sourceSystemIdentifier?: string | null;
}
/**
 * 
 * @export
 * @interface BeneficiaryPersonPercentageDto
 */
export interface BeneficiaryPersonPercentageDto {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPersonPercentageDto
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryPersonPercentageDto
     */
    personType?: number;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryPersonPercentageDto
     */
    percentage?: number;
}
/**
 * 
 * @export
 * @interface BeneficiaryPolicyDto
 */
export interface BeneficiaryPolicyDto {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    policyType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    policyCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryPolicyDto
     */
    planCode?: string | null;
}
/**
 * 
 * @export
 * @interface ExternalBeneficiaryPersonDto
 */
export interface ExternalBeneficiaryPersonDto {
    /**
     * 
     * @type {number}
     * @memberof ExternalBeneficiaryPersonDto
     */
    beneficiaryPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    personType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    relationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    address1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    address3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    sourceSystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    sourceSystemIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    dateOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    lastUpdatedDateTimeStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPersonDto
     */
    signatureDate?: string | null;
}
/**
 * 
 * @export
 * @interface ExternalBeneficiaryPolicyDto
 */
export interface ExternalBeneficiaryPolicyDto {
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPolicyDto
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalBeneficiaryPolicyDto
     */
    lastUpdatedBy?: string | null;
    /**
     * 
     * @type {Array<ExternalBeneficiaryPersonDto>}
     * @memberof ExternalBeneficiaryPolicyDto
     */
    persons?: Array<ExternalBeneficiaryPersonDto> | null;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfBeneficiaryPolicyDto
 */
export interface PagedResultOfBeneficiaryPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBeneficiaryPolicyDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBeneficiaryPolicyDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<BeneficiaryPolicyDto>}
     * @memberof PagedResultOfBeneficiaryPolicyDto
     */
    result?: Array<BeneficiaryPolicyDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfBeneficiaryPolicyDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PersonDto
 */
export interface PersonDto {
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    personType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    ssn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    hireDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    dob?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    relationshipToPI?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    issecondarycontact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    address1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    address3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    beneficiaryPercent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    riderCd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    signatureDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    pLastUpdatedTs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    pLastUpdatedBy?: string | null;
}
/**
 * 
 * @export
 * @interface PolicyDto
 */
export interface PolicyDto {
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    fullPolicyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    policyType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    policyCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    planCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    situs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    issueDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    faceValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    issueOption?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    writingStatusCd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    writingStatusDesc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    statusCd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    statusDesc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    terminatedDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    terminatedReasonCd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    terminatedReasonDesc?: string | null;
}
/**
 * 
 * @export
 * @interface RejectedBeneficiariesResponse
 */
export interface RejectedBeneficiariesResponse {
    /**
     * 
     * @type {string}
     * @memberof RejectedBeneficiariesResponse
     */
    message?: string | null;
    /**
     * 
     * @type {Array<BeneficiaryDto>}
     * @memberof RejectedBeneficiariesResponse
     */
    rejectedBeneficiaries?: Array<BeneficiaryDto> | null;
}
/**
 * 
 * @export
 * @interface RejectedBeneficiariesResponse2
 */
export interface RejectedBeneficiariesResponse2 {
    /**
     * 
     * @type {string}
     * @memberof RejectedBeneficiariesResponse2
     */
    message?: string | null;
    /**
     * 
     * @type {Array<BeneficiaryDto>}
     * @memberof RejectedBeneficiariesResponse2
     */
    rejectedBeneficiaries?: Array<BeneficiaryDto> | null;
}
/**
 * 
 * @export
 * @interface RejectedBeneficiaryResponse
 */
export interface RejectedBeneficiaryResponse {
    /**
     * 
     * @type {string}
     * @memberof RejectedBeneficiaryResponse
     */
    message?: string | null;
    /**
     * 
     * @type {BeneficiaryDto}
     * @memberof RejectedBeneficiaryResponse
     */
    rejectedBeneficiary?: BeneficiaryDto | null;
}

/**
 * BeneficiariesApi - axios parameter creator
 * @export
 */
export const BeneficiariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBeneficiaryPerson: async (policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling addBeneficiaryPerson.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling addBeneficiaryPerson.');
            }
            // verify required parameter 'beneficiaryPersonDto' is not null or undefined
            if (beneficiaryPersonDto === null || beneficiaryPersonDto === undefined) {
                throw new RequiredError('beneficiaryPersonDto','Required parameter beneficiaryPersonDto was null or undefined when calling addBeneficiaryPerson.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/{policyNumber}`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryPersonDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryPersonDto !== undefined ? beneficiaryPersonDto : {}) : (beneficiaryPersonDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiaryDetails: async (policyNumber: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling beneficiaryDetails.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling beneficiaryDetails.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/{policyNumber}/details`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBeneficiaryPerson: async (policyNumber: string, id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling deleteBeneficiaryPerson.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteBeneficiaryPerson.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling deleteBeneficiaryPerson.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/{policyNumber}/person/{id}`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBeneficiaries: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonPercentageDto>} beneficiaryPersonPercentageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPercentages: async (policyNumber: string, version: string, beneficiaryPersonPercentageDto: Array<BeneficiaryPersonPercentageDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling updateBeneficiaryPercentages.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateBeneficiaryPercentages.');
            }
            // verify required parameter 'beneficiaryPersonPercentageDto' is not null or undefined
            if (beneficiaryPersonPercentageDto === null || beneficiaryPersonPercentageDto === undefined) {
                throw new RequiredError('beneficiaryPersonPercentageDto','Required parameter beneficiaryPersonPercentageDto was null or undefined when calling updateBeneficiaryPercentages.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/{policyNumber}/beneficiarypercentages`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryPersonPercentageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryPersonPercentageDto !== undefined ? beneficiaryPersonPercentageDto : {}) : (beneficiaryPersonPercentageDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPerson: async (policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling updateBeneficiaryPerson.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateBeneficiaryPerson.');
            }
            // verify required parameter 'beneficiaryPersonDto' is not null or undefined
            if (beneficiaryPersonDto === null || beneficiaryPersonDto === undefined) {
                throw new RequiredError('beneficiaryPersonDto','Required parameter beneficiaryPersonDto was null or undefined when calling updateBeneficiaryPerson.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/{policyNumber}/person/update`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryPersonDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryPersonDto !== undefined ? beneficiaryPersonDto : {}) : (beneficiaryPersonDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonDto>} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPolicy: async (policyNumber: string, version: string, beneficiaryPersonDto: Array<BeneficiaryPersonDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling updateBeneficiaryPolicy.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateBeneficiaryPolicy.');
            }
            // verify required parameter 'beneficiaryPersonDto' is not null or undefined
            if (beneficiaryPersonDto === null || beneficiaryPersonDto === undefined) {
                throw new RequiredError('beneficiaryPersonDto','Required parameter beneficiaryPersonDto was null or undefined when calling updateBeneficiaryPolicy.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/policy/{policyNumber}`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryPersonDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryPersonDto !== undefined ? beneficiaryPersonDto : {}) : (beneficiaryPersonDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BeneficiariesApi - functional programming interface
 * @export
 */
export const BeneficiariesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BeneficiaryPersonDto>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).addBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beneficiaryDetails(policyNumber: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BeneficiaryPersonDto>>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).beneficiaryDetails(policyNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBeneficiaryPerson(policyNumber: string, id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).deleteBeneficiaryPerson(policyNumber, id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBeneficiaries(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfBeneficiaryPolicyDto>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).searchBeneficiaries(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonPercentageDto>} beneficiaryPersonPercentageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBeneficiaryPercentages(policyNumber: string, version: string, beneficiaryPersonPercentageDto: Array<BeneficiaryPersonPercentageDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).updateBeneficiaryPercentages(policyNumber, version, beneficiaryPersonPercentageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BeneficiaryPersonDto>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).updateBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonDto>} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBeneficiaryPolicy(policyNumber: string, version: string, beneficiaryPersonDto: Array<BeneficiaryPersonDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BeneficiariesApiAxiosParamCreator(configuration).updateBeneficiaryPolicy(policyNumber, version, beneficiaryPersonDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BeneficiariesApi - factory interface
 * @export
 */
export const BeneficiariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any): AxiosPromise<BeneficiaryPersonDto> {
            return BeneficiariesApiFp(configuration).addBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiaryDetails(policyNumber: string, version: string, options?: any): AxiosPromise<Array<BeneficiaryPersonDto>> {
            return BeneficiariesApiFp(configuration).beneficiaryDetails(policyNumber, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBeneficiaryPerson(policyNumber: string, id: string, version: string, options?: any): AxiosPromise<void> {
            return BeneficiariesApiFp(configuration).deleteBeneficiaryPerson(policyNumber, id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBeneficiaries(version: string, options?: any): AxiosPromise<PagedResultOfBeneficiaryPolicyDto> {
            return BeneficiariesApiFp(configuration).searchBeneficiaries(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonPercentageDto>} beneficiaryPersonPercentageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPercentages(policyNumber: string, version: string, beneficiaryPersonPercentageDto: Array<BeneficiaryPersonPercentageDto>, options?: any): AxiosPromise<void> {
            return BeneficiariesApiFp(configuration).updateBeneficiaryPercentages(policyNumber, version, beneficiaryPersonPercentageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any): AxiosPromise<BeneficiaryPersonDto> {
            return BeneficiariesApiFp(configuration).updateBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {Array<BeneficiaryPersonDto>} beneficiaryPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPolicy(policyNumber: string, version: string, beneficiaryPersonDto: Array<BeneficiaryPersonDto>, options?: any): AxiosPromise<void> {
            return BeneficiariesApiFp(configuration).updateBeneficiaryPolicy(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BeneficiariesApi - object-oriented interface
 * @export
 * @class BeneficiariesApi
 * @extends {BaseAPI}
 */
export class BeneficiariesApi extends BaseAPI {
    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public addBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any) {
        return BeneficiariesApiFp(this.configuration).addBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public beneficiaryDetails(policyNumber: string, version: string, options?: any) {
        return BeneficiariesApiFp(this.configuration).beneficiaryDetails(policyNumber, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} policyNumber 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public deleteBeneficiaryPerson(policyNumber: string, id: string, version: string, options?: any) {
        return BeneficiariesApiFp(this.configuration).deleteBeneficiaryPerson(policyNumber, id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public searchBeneficiaries(version: string, options?: any) {
        return BeneficiariesApiFp(this.configuration).searchBeneficiaries(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {Array<BeneficiaryPersonPercentageDto>} beneficiaryPersonPercentageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public updateBeneficiaryPercentages(policyNumber: string, version: string, beneficiaryPersonPercentageDto: Array<BeneficiaryPersonPercentageDto>, options?: any) {
        return BeneficiariesApiFp(this.configuration).updateBeneficiaryPercentages(policyNumber, version, beneficiaryPersonPercentageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {BeneficiaryPersonDto} beneficiaryPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public updateBeneficiaryPerson(policyNumber: string, version: string, beneficiaryPersonDto: BeneficiaryPersonDto, options?: any) {
        return BeneficiariesApiFp(this.configuration).updateBeneficiaryPerson(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {Array<BeneficiaryPersonDto>} beneficiaryPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    public updateBeneficiaryPolicy(policyNumber: string, version: string, beneficiaryPersonDto: Array<BeneficiaryPersonDto>, options?: any) {
        return BeneficiariesApiFp(this.configuration).updateBeneficiaryPolicy(policyNumber, version, beneficiaryPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async heartbeatGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LifeBulkApi - axios parameter creator
 * @export
 */
export const LifeBulkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeneficiaryByPolicyNumber: async (policyNumber: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling getBeneficiaryByPolicyNumber.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getBeneficiaryByPolicyNumber.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/lifebulk/{policyNumber}`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBeneficiaries: async (version: string, beneficiaryDto: Array<BeneficiaryDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling loadBeneficiaries.');
            }
            // verify required parameter 'beneficiaryDto' is not null or undefined
            if (beneficiaryDto === null || beneficiaryDto === undefined) {
                throw new RequiredError('beneficiaryDto','Required parameter beneficiaryDto was null or undefined when calling loadBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/lifebulk/load`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryDto !== undefined ? beneficiaryDto : {}) : (beneficiaryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {ExternalBeneficiaryPolicyDto} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryFromAppEntry: async (version: string, externalBeneficiaryPolicyDto: ExternalBeneficiaryPolicyDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateBeneficiaryFromAppEntry.');
            }
            // verify required parameter 'externalBeneficiaryPolicyDto' is not null or undefined
            if (externalBeneficiaryPolicyDto === null || externalBeneficiaryPolicyDto === undefined) {
                throw new RequiredError('externalBeneficiaryPolicyDto','Required parameter externalBeneficiaryPolicyDto was null or undefined when calling updateBeneficiaryFromAppEntry.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/lifebulk`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof externalBeneficiaryPolicyDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(externalBeneficiaryPolicyDto !== undefined ? externalBeneficiaryPolicyDto : {}) : (externalBeneficiaryPolicyDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPolicyStatus: async (version: string, beneficiaryDto: BeneficiaryDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateBeneficiaryPolicyStatus.');
            }
            // verify required parameter 'beneficiaryDto' is not null or undefined
            if (beneficiaryDto === null || beneficiaryDto === undefined) {
                throw new RequiredError('beneficiaryDto','Required parameter beneficiaryDto was null or undefined when calling updateBeneficiaryPolicyStatus.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/lifebulk/beneficiarypolicystatus`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryDto !== undefined ? beneficiaryDto : {}) : (beneficiaryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryInsuredAndPolicyOwnerContactsFromCSR: async (version: string, beneficiaryDto: BeneficiaryDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updatePrimaryInsuredAndPolicyOwnerContactsFromCSR.');
            }
            // verify required parameter 'beneficiaryDto' is not null or undefined
            if (beneficiaryDto === null || beneficiaryDto === undefined) {
                throw new RequiredError('beneficiaryDto','Required parameter beneficiaryDto was null or undefined when calling updatePrimaryInsuredAndPolicyOwnerContactsFromCSR.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/lifebulk/primaryinsuredandpolicyownercontact`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryDto !== undefined ? beneficiaryDto : {}) : (beneficiaryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LifeBulkApi - functional programming interface
 * @export
 */
export const LifeBulkApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBeneficiaryByPolicyNumber(policyNumber: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalBeneficiaryPolicyDto>> {
            const localVarAxiosArgs = await LifeBulkApiAxiosParamCreator(configuration).getBeneficiaryByPolicyNumber(policyNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await LifeBulkApiAxiosParamCreator(configuration).loadBeneficiaries(version, beneficiaryDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {ExternalBeneficiaryPolicyDto} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBeneficiaryFromAppEntry(version: string, externalBeneficiaryPolicyDto: ExternalBeneficiaryPolicyDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await LifeBulkApiAxiosParamCreator(configuration).updateBeneficiaryFromAppEntry(version, externalBeneficiaryPolicyDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBeneficiaryPolicyStatus(version: string, beneficiaryDto: BeneficiaryDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await LifeBulkApiAxiosParamCreator(configuration).updateBeneficiaryPolicyStatus(version, beneficiaryDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version: string, beneficiaryDto: BeneficiaryDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await LifeBulkApiAxiosParamCreator(configuration).updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version, beneficiaryDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LifeBulkApi - factory interface
 * @export
 */
export const LifeBulkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeneficiaryByPolicyNumber(policyNumber: string, version: string, options?: any): AxiosPromise<ExternalBeneficiaryPolicyDto> {
            return LifeBulkApiFp(configuration).getBeneficiaryByPolicyNumber(policyNumber, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, options?: any): AxiosPromise<number> {
            return LifeBulkApiFp(configuration).loadBeneficiaries(version, beneficiaryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {ExternalBeneficiaryPolicyDto} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryFromAppEntry(version: string, externalBeneficiaryPolicyDto: ExternalBeneficiaryPolicyDto, options?: any): AxiosPromise<number> {
            return LifeBulkApiFp(configuration).updateBeneficiaryFromAppEntry(version, externalBeneficiaryPolicyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBeneficiaryPolicyStatus(version: string, beneficiaryDto: BeneficiaryDto, options?: any): AxiosPromise<number> {
            return LifeBulkApiFp(configuration).updateBeneficiaryPolicyStatus(version, beneficiaryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {BeneficiaryDto} beneficiaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version: string, beneficiaryDto: BeneficiaryDto, options?: any): AxiosPromise<number> {
            return LifeBulkApiFp(configuration).updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version, beneficiaryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LifeBulkApi - object-oriented interface
 * @export
 * @class LifeBulkApi
 * @extends {BaseAPI}
 */
export class LifeBulkApi extends BaseAPI {
    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeBulkApi
     */
    public getBeneficiaryByPolicyNumber(policyNumber: string, version: string, options?: any) {
        return LifeBulkApiFp(this.configuration).getBeneficiaryByPolicyNumber(policyNumber, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {Array<BeneficiaryDto>} beneficiaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeBulkApi
     */
    public loadBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, options?: any) {
        return LifeBulkApiFp(this.configuration).loadBeneficiaries(version, beneficiaryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {ExternalBeneficiaryPolicyDto} externalBeneficiaryPolicyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeBulkApi
     */
    public updateBeneficiaryFromAppEntry(version: string, externalBeneficiaryPolicyDto: ExternalBeneficiaryPolicyDto, options?: any) {
        return LifeBulkApiFp(this.configuration).updateBeneficiaryFromAppEntry(version, externalBeneficiaryPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {BeneficiaryDto} beneficiaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeBulkApi
     */
    public updateBeneficiaryPolicyStatus(version: string, beneficiaryDto: BeneficiaryDto, options?: any) {
        return LifeBulkApiFp(this.configuration).updateBeneficiaryPolicyStatus(version, beneficiaryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {BeneficiaryDto} beneficiaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeBulkApi
     */
    public updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version: string, beneficiaryDto: BeneficiaryDto, options?: any) {
        return LifeBulkApiFp(this.configuration).updatePrimaryInsuredAndPolicyOwnerContactsFromCSR(version, beneficiaryDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WalmartApi - axios parameter creator
 * @export
 */
export const WalmartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentWalmartBeneficiaries: async (version: string, policyNumbers?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getCurrentWalmartBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/walmart`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policyNumbers) {
                localVarQueryParameter['policyNumbers'] = policyNumbers;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalWalmartBeneficiaries: async (version: string, policyNumbers?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getHistoricalWalmartBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/walmart/history`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policyNumbers) {
                localVarQueryParameter['policyNumbers'] = policyNumbers;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {boolean} [includeUpdates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadWalmartBeneficiaries: async (version: string, beneficiaryDto: Array<BeneficiaryDto>, includeUpdates?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling loadWalmartBeneficiaries.');
            }
            // verify required parameter 'beneficiaryDto' is not null or undefined
            if (beneficiaryDto === null || beneficiaryDto === undefined) {
                throw new RequiredError('beneficiaryDto','Required parameter beneficiaryDto was null or undefined when calling loadWalmartBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/walmart/load`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (includeUpdates !== undefined) {
                localVarQueryParameter['includeUpdates'] = includeUpdates;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof beneficiaryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(beneficiaryDto !== undefined ? beneficiaryDto : {}) : (beneficiaryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<ExternalBeneficiaryPolicyDto>} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalmartBeneficiaries: async (version: string, externalBeneficiaryPolicyDto: Array<ExternalBeneficiaryPolicyDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateWalmartBeneficiaries.');
            }
            // verify required parameter 'externalBeneficiaryPolicyDto' is not null or undefined
            if (externalBeneficiaryPolicyDto === null || externalBeneficiaryPolicyDto === undefined) {
                throw new RequiredError('externalBeneficiaryPolicyDto','Required parameter externalBeneficiaryPolicyDto was null or undefined when calling updateWalmartBeneficiaries.');
            }
            const localVarPath = `/api/v{version}/beneficiaries/walmart`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof externalBeneficiaryPolicyDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(externalBeneficiaryPolicyDto !== undefined ? externalBeneficiaryPolicyDto : {}) : (externalBeneficiaryPolicyDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WalmartApi - functional programming interface
 * @export
 */
export const WalmartApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalBeneficiaryPolicyDto>>> {
            const localVarAxiosArgs = await WalmartApiAxiosParamCreator(configuration).getCurrentWalmartBeneficiaries(version, policyNumbers, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoricalWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<ExternalBeneficiaryPolicyDto>; }>> {
            const localVarAxiosArgs = await WalmartApiAxiosParamCreator(configuration).getHistoricalWalmartBeneficiaries(version, policyNumbers, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {boolean} [includeUpdates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadWalmartBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, includeUpdates?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await WalmartApiAxiosParamCreator(configuration).loadWalmartBeneficiaries(version, beneficiaryDto, includeUpdates, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<ExternalBeneficiaryPolicyDto>} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWalmartBeneficiaries(version: string, externalBeneficiaryPolicyDto: Array<ExternalBeneficiaryPolicyDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await WalmartApiAxiosParamCreator(configuration).updateWalmartBeneficiaries(version, externalBeneficiaryPolicyDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WalmartApi - factory interface
 * @export
 */
export const WalmartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any): AxiosPromise<Array<ExternalBeneficiaryPolicyDto>> {
            return WalmartApiFp(configuration).getCurrentWalmartBeneficiaries(version, policyNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [policyNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<ExternalBeneficiaryPolicyDto>; }> {
            return WalmartApiFp(configuration).getHistoricalWalmartBeneficiaries(version, policyNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<BeneficiaryDto>} beneficiaryDto 
         * @param {boolean} [includeUpdates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadWalmartBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, includeUpdates?: boolean, options?: any): AxiosPromise<number> {
            return WalmartApiFp(configuration).loadWalmartBeneficiaries(version, beneficiaryDto, includeUpdates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<ExternalBeneficiaryPolicyDto>} externalBeneficiaryPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalmartBeneficiaries(version: string, externalBeneficiaryPolicyDto: Array<ExternalBeneficiaryPolicyDto>, options?: any): AxiosPromise<number> {
            return WalmartApiFp(configuration).updateWalmartBeneficiaries(version, externalBeneficiaryPolicyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WalmartApi - object-oriented interface
 * @export
 * @class WalmartApi
 * @extends {BaseAPI}
 */
export class WalmartApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {Array<string>} [policyNumbers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalmartApi
     */
    public getCurrentWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any) {
        return WalmartApiFp(this.configuration).getCurrentWalmartBeneficiaries(version, policyNumbers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {Array<string>} [policyNumbers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalmartApi
     */
    public getHistoricalWalmartBeneficiaries(version: string, policyNumbers?: Array<string>, options?: any) {
        return WalmartApiFp(this.configuration).getHistoricalWalmartBeneficiaries(version, policyNumbers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {Array<BeneficiaryDto>} beneficiaryDto 
     * @param {boolean} [includeUpdates] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalmartApi
     */
    public loadWalmartBeneficiaries(version: string, beneficiaryDto: Array<BeneficiaryDto>, includeUpdates?: boolean, options?: any) {
        return WalmartApiFp(this.configuration).loadWalmartBeneficiaries(version, beneficiaryDto, includeUpdates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {Array<ExternalBeneficiaryPolicyDto>} externalBeneficiaryPolicyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalmartApi
     */
    public updateWalmartBeneficiaries(version: string, externalBeneficiaryPolicyDto: Array<ExternalBeneficiaryPolicyDto>, options?: any) {
        return WalmartApiFp(this.configuration).updateWalmartBeneficiaries(version, externalBeneficiaryPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

}


